import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { isEqual, pick, isNull } from 'lodash';
import moment from 'moment-timezone';
import { Panel, Button } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';
import utils, { constants } from '@utils';
import { ExpandableContext } from '@components/contexts';
import JobActions, { thunks } from '@redux/jobs';
import Officers from './officers';

class PositionsPanel extends Component {
	shouldComponentUpdate = ({
		positions,
		jobEventStatusId,
	}) => {
		const lastProps = this.props;

		return (
			!isEqual(positions, lastProps.positions)
			|| !isEqual(jobEventStatusId, lastProps.jobEventStatusId)
		);
	}

	onEnter = (positionId) => () => {
		const {
			getApplicantsByPositionId,
			getAssignedOfficersByPositionId,
		} = this.props;

		getApplicantsByPositionId(positionId);
		getAssignedOfficersByPositionId(positionId);
	}

	render() {
		const {
			user : {
				TimeZoneId : userTimeZone,
			},
			jobTimeZone,
			positions,
			jobEventStatusId,
			JobEventTypeId,
		} = this.props;

		const isActiveJob = jobEventStatusId === constants.JOB_TYPES.active.type;
		const isUpcomingJob = jobEventStatusId === constants.JOB_TYPES.upcoming.type;
		const jobTimeZoneId = isNull(jobTimeZone) ? userTimeZone : jobTimeZone;

		return (
			<React.Fragment>
				<Panel className="details-panel details-panel__expandable-container">
					<Panel.Heading className="details-panel__expandable-heading ">
						Positions
					</Panel.Heading>
					<For
						index="index"
						each="position"
						of={positions}
					>
						<ExpandableContext.Provider key={`position_${index}`}>
							<ExpandableContext.Consumer>
								{ ({ expanded, onToggle }) => (
									<Panel
										expanded={expanded}
										onToggle={() => {}}
										className={classNames('inner-panel', { active : expanded })}
									>
										<Panel.Heading
											className={classNames('details-panel__expandable-heading', {
												active : expanded,
											})}
										>
											<Button onClick={onToggle}>
												<div className="flex width-all">
													<div className="flex-2 text-wrap margin-right-10">
														<h5 className="position-details-heading">
															{ position.Title }
														</h5>
														<If condition={JobEventTypeId === constants.FORM_JOB_TYPES.EVENT.value}>
															<p className="font-size-12 margin-top-5 margin-bottom-0">
																<span>
																	{ utils.parseUTCDateToTimeZone(position.StartDateTime, jobTimeZoneId).format('h:mm A') }
																</span>
																<span> - </span>
																<span>
																	{ utils.parseUTCDateToTimeZone(position.EndDateTime, jobTimeZoneId).format('h:mm A') }
																</span>
																<span>
																	{' '}
																	{ moment.tz(jobTimeZoneId).zoneAbbr() }
																	{' '}
																</span>

																<If condition={userTimeZone !== jobTimeZoneId}>
																	<br />
																	<span>
																		{ utils.parseUTCDateToTimeZone(position.StartDateTime, userTimeZone).format('h:mm A') }
																	</span>
																	<span> - </span>
																	<span>
																		{ utils.parseUTCDateToTimeZone(position.EndDateTime, userTimeZone).format('h:mm A') }
																	</span>
																	<span>
																		{' '}
																		{ moment.tz(userTimeZone).zoneAbbr() }
																		{' '}
																		(Local Timezone)
																	</span>
																</If>
															</p>
														</If>
													</div>
													<div className="flex-1 margin-right-10">
														<div className="flex flex-align-items-center">
															<If condition={isActiveJob || isUpcomingJob}>
																<div
																	className={classNames('tag', {
																		'tag-danger'  : position.ApplicantsNotViewedCount > 0 && isUpcomingJob,
																		'tag-success' : isActiveJob,
																	})}
																>
																	<Choose>
																		<When condition={isUpcomingJob}>
																			{ position.ApplicantsNotViewedCount > 0
																				? `${position.ApplicantsNotViewedCount}`
																				: 'No' }
																			{' '}
																			New Applicant
																			{ position.ApplicantsNotViewedCount === 1 ? '' : 's' }
																		</When>
																		<When condition={isActiveJob}>
																			{ constants.JOB_TYPES.active.displayName }
																		</When>
																	</Choose>
																</div>
															</If>
														</div>
													</div>
													<div className="flex-1">
														<div className="flex flex-justify-content-space-between flex-align-items-center">
															<div className="text-center">
																<h4 className="font-semi-bold font-weight-600 font-size-16 margin-bottom-5 margin-top-0">
																	{ `$${position.Rate}` }
																</h4>
																<p className="font-size-12 margin-bottom-0 color-gray-dove">
																	Rate
																</p>
															</div>
															<div className="text-center">
																<h4 className="font-semi-bold font-weight-600 font-size-16 margin-bottom-5 margin-top-0">
																	{ position.AssignedOfficersCount }
																	{' '}
																	/
																	{ position.OfficersNeeded }
																</h4>
																<p className="font-size-12 margin-bottom-0 color-gray-dove">
																	Filled
																</p>
															</div>
															<div className="details-panel__expandable-button">
																<i className={classNames('rkf rkf-chevron-down color-blue-azure-radiance transition-transform',
																	{
																		'transform-rotate-180' : expanded,
																	})}
																/>
															</div>
														</div>
													</div>
												</div>
											</Button>
										</Panel.Heading>
										<Panel.Collapse onEnter={this.onEnter(position.Id)}>
											<Panel.Body className="bg-white padding-0">
												<Officers
													positionId={position.Id}
												/>
												<ExpandableContext.Provider key={`position_${index}`}>
													<ExpandableContext.Consumer>
														{ ({
															expanded : expandedDetails,
															onToggle : onToggleDetails,
														}) => (
															<Panel
																className={classNames('inner-panel bg-white upside-down', {
																	expanded : expandedDetails,
																})}
																expanded={expandedDetails}
																onToggle={() => {}}
															>
																<Panel.Collapse>
																	<Panel.Body>
																		<div className="color-gray-dove margin-bottom-20">
																			{ position.Details }
																		</div>
																		<div className="flex">
																			<h4 className="margin-0 font-semi-bold font-size-14 font-weight-600">
																				Requirements
																			</h4>
																			<ul className="margin-left-73">
																				<If condition={position.VehicleRequired}>
																					<li>
																						<span className="font-bold">Vehicle</span>
																						{' '}
																						is required for this position.
																					</li>
																					<If condition={position.VehicleTypes.length > 0}>
																						<li>
																							<span className="font-bold">Vehicle types:</span>
																							<ul>
																								<For
																									index="index"
																									each="vehicle"
																									of={position.VehicleTypes}
																								>
																									<li key={`vehicle_${index}_${vehicle.Id}`}>
																										{ vehicle.Name }
																									</li>
																								</For>
																							</ul>
																						</li>
																					</If>
																				</If>
																				<li>
																					<span className="font-bold">Dress Type: </span>
																					{ position.DressTypeName ? position.DressTypeName : 'Unspecified' }
																					<If condition={position.DressTypeNote}>
																						<ul>
																							<li>
																								<span className="font-bold">Notes:</span>
																								<ReactMarkdown source={position.DressTypeNote} />
																							</li>
																						</ul>
																					</If>
																				</li>
																				<li>
																					<span className="font-bold">Other Requirements:</span>
																				</li>
																				<Choose>
																					<When condition={position.OfficerRequirements}>
																						<ReactMarkdown source={position.OfficerRequirements} />
																					</When>
																					<Otherwise>
																						<span>Not Specified.</span>
																					</Otherwise>
																				</Choose>
																			</ul>
																		</div>
																	</Panel.Body>
																</Panel.Collapse>
																<Panel.Heading className="bg-white">
																	<Button
																		bsSize="xsmall"
																		bsStyle="link"
																		onClick={onToggleDetails}
																		className="flex flex-align-items-center"
																	>
																		<i
																			className={classNames('rkf rkf-arrow-down transition-transform', {
																				'transform-rotate-180' : expandedDetails,
																			})}
																		/>
																		<span className="padding-left-9">
																			{ `${expandedDetails ? 'Hide' : 'Show'}` }
																			{' '}
																			Position details and Instructions
																		</span>
																	</Button>
																</Panel.Heading>
															</Panel>
														) }
													</ExpandableContext.Consumer>
												</ExpandableContext.Provider>
											</Panel.Body>
										</Panel.Collapse>
									</Panel>
								) }
							</ExpandableContext.Consumer>
						</ExpandableContext.Provider>
					</For>
				</Panel>
			</React.Fragment>
		);
	}
}

const mapStateToProps = ({
	app  : { user },
	jobs : {
		jobEvent : {
			StatusId : jobEventStatusId,
			Jobs     : positions,
			TimeZoneId : jobTimeZone,
			JobEventTypeId,
		},
	},
}) => ({
	user,
	jobEventStatusId,
	positions,
	jobTimeZone,
	JobEventTypeId,
});

const mapDispatchToProps = (dispatch) => ({
	...pick(bindActionCreators(JobActions, dispatch), ['setModalOpen']),
	...pick(bindActionCreators(thunks, dispatch), [
		'getApplicantsByPositionId',
		'getAssignedOfficersByPositionId',
	]),
});

PositionsPanel.propTypes = {
	JobEventTypeId : PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
	]),
	getApplicantsByPositionId       : PropTypes.func.isRequired,
	getAssignedOfficersByPositionId : PropTypes.func.isRequired,
	jobEventStatusId                : PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
	]),
	jobTimeZone : PropTypes.string,
	positions   : PropTypes.array,
	user        : PropTypes.object,
};

PositionsPanel.defaultProps = {
	JobEventTypeId   : '',
	jobEventStatusId : '',
	jobTimeZone      : '',
	positions        : [],
	user             : {},
};

export default connect(mapStateToProps, mapDispatchToProps)(PositionsPanel);
